import type { IOrganisation } from './organisation';
import { organisationAddressSchema } from './organisation';
import type { SchemaOf } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';

export interface IGetOrganisationParams {
  organisationId: string;
}

export const getOrganisationParamsSchema = objectSchemaOf<IGetOrganisationParams>(
  {
    organisationId: Joi.string().required(),
  }
);

export type IUpdateOrganisationParams = Partial<IOrganisation> & {
  organisationId: string;
};

export const updateOrganisationParamsSchemaMap: SchemaOf<IOrganisation> = {
  organisationId: Joi.string().required(),
  contactEmail: Joi.string().optional(),
  contactName: Joi.string().optional(),
  contactNumber: Joi.string().optional(),
  organisationName: Joi.string().optional(),
  logoUrl: Joi.string().optional(),
  abn: Joi.string().optional(),
  address: organisationAddressSchema.optional(),
  security: Joi.object({
    contactName: Joi.string().required(),
    contactNumber: Joi.string().required(),
  }).optional(),
  notes: Joi.string().optional(),
  isMultiTenant: Joi.string().optional(),
};

export const updateOrganisationParamsSchema = objectSchemaOf<IOrganisation>(
  updateOrganisationParamsSchemaMap
);
